import React from 'react';

const Legal: React.FC = () => {
  return (
    <div className="card">
      <div className="card-header">
        <h5 className="mb-0">Legal</h5>
      </div>
      <div className="card-body">
        <p className="mb-0">All legal notices, disclaimers, and policies related to the use of this application.</p>
      </div>
    </div>
  );
};

export default Legal;
